import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InteresseControllerService } from '../../../api-clients/generated/services/AnmcoBackend/api/interesseController.service';
import { UserInteresseResponseDTO } from '../../../api-clients/generated/services/AnmcoBackend/model/userInteresseResponseDTO';
import { UserInteresseRequestDTO } from '../../../api-clients/generated/services/AnmcoBackend/model/userInteresseRequestDTO';

@Injectable({ providedIn: 'root' })
export class InterestsService {

  constructor(private interesseController: InteresseControllerService) {}

  getInteressiUtente(): Observable<UserInteresseResponseDTO[]> {
    return this.interesseController.getInteressiUtente();
  }

  aggiornaInteressi(interessiIds: string[]): Observable<UserInteresseResponseDTO[]> {
    const request: UserInteresseRequestDTO = { interessiIds };
    return this.interesseController.aggiornaInteressiUtente(request);
  }
}
